const radioPlayer = {
    namespaced: true,
    state: {
        currentStream: null,
        playing: false
    },

    mutations: {
        setCurrentStream(state, payload) {
            state.currentStream = payload;
        },
        setPlaying(state, payload) {
            state.playing = payload;
        }
    },
    getters: {
        getCurrentStream: state => state.currentStream,
        getPlaying: state => state.playing
    }
}

export default radioPlayer;